import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import axios from 'axios';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Loader from '../../components/loader';

function App() {
  const [reciepts, setReciepts] = useState([]);
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [loading, setLoading] = useState(false);
  

  const months = Array.from({ length: 12 }, (_, i) =>
    new Date(0, i).toLocaleString("default", { month: "long" })
  );

  const fetchDateData = async () => {
    setLoading(true);
    const sendData = {
      year: year,
      month: month
    };
    try {
      const response = await axios.post('https://api.trucoo.in/ledger/party-outstand/', sendData, {
        headers: {
          'Content-Type': 'application/json',
          'X-API-KEY': 'erpTrucoo'
      }});

      console.log(response?.data);

      if(response?.data?.status === 'success'){
        setReciepts(response?.data?.data);
      }else{
        setReciepts([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDateData();
  }, [year, month]);

  const getTotalSales = (data) => {
    let total = 0;
    data.forEach((item) => {
      total += Number(item?.totalPayment || 0);
    });
    return total;
  };

  const getTotalBank = (data) => {
    let total = 0;
    data.forEach((item) => {
      total += Number(item?.amount || 0);
    });
    return total;
  };

  const getTotalReceipts = (data) => {
    let total = 0;
    data.forEach((item) => {
      total += Number(item?.receipt_amount || 0);
    });
    return total;
  };

  const getCDnote = (data) => {
    let creditTotal = 0;
    let debitTotal = 0;
    if (!Array.isArray(data)) return { creditTotal: 0, debitTotal: 0 };
    data?.forEach((item) => {
      if(item?.type === 'credit'){
        creditTotal += Number(item?.amount || 0);
      }else if(item?.type === 'debit'){
        debitTotal += Number(item?.amount || 0);
      }
    });
    return {creditTotal, debitTotal};
  };

  let opeingTotalValue = 0;
  let salesTotalValue = 0;
  let receiptTotalValue = 0;
  let debitTotalValue = 0;
  let creditTotalValue = 0;
  let closingTotalValue = 0;
  let bankTotalValue = 0;

  
  return (
    <>
     {loading && <Loader />}
      <Header />
      <Sidebar />
      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="col-12">
              <div className="box">
                <div className="box-header with-border">
                   <h4 className="box-title">Party Ledger Data</h4>
                   <div className="box-tools pull-right">
                    <div className='flex gap-2'>
                      {/* <p className='mt-2' style={{minWidth: '400px'}}>Payment for {year} {month && month !== 'all' ? new Date(0, month - 1).toLocaleString("default", { month: "long" }) : ''} is <span className='text-bold'>{Number(totalAmount).toFixed(2)}</span></p> */}
                      <select value={year} onChange={(e) => setYear(e.target.value)} className='form-select' style={{minWidth: '90px'}}>
                        <option value="all">All Years</option>
                        {Array.from(
                          { length: currentYear - 2023 + 1 },
                          (_, i) => currentYear - i
                        ).map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}

                      </select>
                      {year !== 'all' && (
                        <select value={month} onChange={(e) => setMonth(Number(e.target.value))} className='form-select' style={{minWidth: '120px'}}>
                          <option value="all">All Months</option>
                          {months.map((month, index) => (
                            <option key={index} value={index + 1}>
                              {month}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                   </div>
                </div>
                <div className="box-body">
                  
                  <div className="table-responsive" style={{width: '100%', height: 'calc(100vh - 230px)', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                    <table className="table-sm fs-12 text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
                      <thead>
                         <tr className="text-dark text-center" style={{ position: 'sticky', top: -1, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                          <th className='text-center'>S.No</th>
                          <th className='text-center'>Code</th>
                          <th>Party</th>
                          <th className='text-end'>Opening Balance</th>
                          <th className='text-end'>Sales</th>
                          <th className='text-end'>Receipts</th>
                          <th className='text-end'>Debit Note</th>
                          <th className='text-end'>Credit Note</th>
                          <th className='text-end'>Bank Collection</th>
                          <th className='text-end'>Closing Balance</th>
                          <th className='text-center'>View</th>
                        </tr>
                      </thead>
                      <tbody>
                          {reciepts?.length > 0 ?
                            reciepts?.map((payment, index) => {
                              const invoiceTotal = getTotalSales(payment?.invoices || []);
                              const receiptTotal = getTotalReceipts(payment?.receipts || []);
                              const obSales = getTotalSales(payment?.obInvoices || []);
                              const obReceipts = getTotalReceipts(payment?.obReceipts || []);
                              const bankCollection = getTotalBank(payment?.bankCollection || []);
                              const obBankCollection = getTotalBank(payment?.obBankCollection || []);
                              const {creditTotal, debitTotal} = getCDnote(payment?.cdNotes || []);
                              const { creditTotal: obCreditTotal, debitTotal: obDebitTotal } = getCDnote(payment?.obCDNotes || []);

                              const openingBalance = obSales + obDebitTotal - obReceipts - obBankCollection - obCreditTotal;
                              const closingBal = openingBalance + (invoiceTotal + debitTotal) - (receiptTotal + creditTotal + bankCollection);
                              
                              salesTotalValue += invoiceTotal;
                              receiptTotalValue += receiptTotal;
                              opeingTotalValue += openingBalance;
                              closingTotalValue += closingBal;
                              debitTotalValue += debitTotal;
                              creditTotalValue += creditTotal;
                              bankTotalValue += bankCollection;
                              
                              return (
                              <tr key={index}>
                                <td className='text-center'>{index + 1}</td>
                                <td className='text-center'>{payment?.id}</td>
                                <td>{payment?.dealer}</td>
                                <td className='text-end'>{Number(openingBalance).toFixed(2)}</td>
                                <td className='text-end'>{Number(invoiceTotal).toFixed(2)}</td>
                                <td className='text-end'>{Number(receiptTotal).toFixed(2)}</td>
                                <td className='text-end'>{Number(debitTotal).toFixed(2)}</td>
                                <td className='text-end'>{Number(creditTotal).toFixed(2)}</td>
                                <td className='text-end'>{Number(bankCollection).toFixed(2)}</td>
                                <td className='text-end'>{Number(closingBal).toFixed(2)}</td>
                                <td className='text-center'>
                                  <Link
                                    className="btn btn-sm btn-light"
                                    to="/party-ledger-view"
                                    state={{ payment, year, month }}
                                  >
                                    View
                                  </Link>
                                </td>
                              </tr>
                            )})
                          :
                            <tr>
                              <td colSpan="9" className="text-center">No records found</td>
                            </tr>
                        }
                        <tr
                          className="text-dark"
                          style={{
                            position: "sticky",
                            bottom: -11,
                            zIndex: 2,
                            backgroundColor: "#f8f9fa",
                          }}
                        >
                          <th colSpan={3}>Total</th>
                          <th className="text-end">{new Intl.NumberFormat('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 2,
                            }).format(opeingTotalValue)}
                          </th>
                          <th className="text-end">{new Intl.NumberFormat('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 2,
                            }).format(salesTotalValue)}
                          </th>
                          <th className="text-end">{new Intl.NumberFormat('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 2,
                            }).format(receiptTotalValue)}
                          </th>
                          <th className="text-end">{new Intl.NumberFormat('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 2,
                            }).format(debitTotalValue)}
                          </th>
                          <th className="text-end">{new Intl.NumberFormat('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 2,
                            }).format(creditTotalValue)}
                          </th>
                          <th className="text-end">{new Intl.NumberFormat('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 2,
                            }).format(bankTotalValue)}
                          </th>
                          <th className="text-end">{new Intl.NumberFormat('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 2,
                            }).format(closingTotalValue)}
                          </th>
                          <th></th>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default App;
